import { useCallback } from 'react';
import { isNil } from 'lodash';
import { useHistory, useLocation } from 'react-router-dom';
// Import Store
import { useAppSelector } from 'store';
import { selectUserActivePartnerId } from 'store/slices/userData';
// Import Helpers
import { queryParamsDecoder, queryParamsEncoder } from 'services/Helpers';
// Import Constants
import { partnerIdQueryNamespace } from 'constants/common';

const useQueryParams = (queryNamespace?: string) => {
    const history = useHistory();
    const { pathname } = useLocation();

    const PartnerId = useAppSelector(selectUserActivePartnerId);

    const encode = useCallback(
        (data) => {
            if (!isNil(queryNamespace)) {
                const queryParams = queryParamsDecoder(window.location.search);
                queryParams[queryNamespace] = data;
                queryParams[partnerIdQueryNamespace] = PartnerId;
                return queryParamsEncoder(queryParams);
            }

            return queryParamsEncoder(data);
        },
        [PartnerId, queryNamespace],
    );

    const decode = useCallback(() => {
        const decodedQueryParams = queryParamsDecoder(window.location.search);
        if (!isNil(queryNamespace) && decodedQueryParams[partnerIdQueryNamespace] === PartnerId) {
            return decodedQueryParams[queryNamespace];
        } else if (isNil(queryNamespace)) {
            return decodedQueryParams;
        }
        return {};
    }, [PartnerId, queryNamespace]);

    const historyReplace = useCallback(
        (data) => {
            history.replace({
                pathname,
                search: encode(data),
            });
        },
        [encode, history, pathname],
    );

    return { encode, decode, historyReplace };
};

export default useQueryParams;
